var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-2 2 34 26",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.5 2.5H27.5V27.5H2.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M27,3v24H3V3H27 M28,2H2v26h26V2L28,2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f78f8f",
    d: "M2.5 2.5H27.5V7.5H2.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c74343",
    d: "M27,3v4H3V3H27 M28,2H2v6h26V2L28,2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c5d4de",
    d: "M10 11H12V13H10zM14 11H16V13H14zM18 11H20V13H18zM22 11H24V13H22zM6 15H8V17H6zM10 15H12V17H10zM14 15H16V17H14zM18 15H20V17H18zM22 15H24V17H22zM6 19H8V21H6zM10 19H12V21H10zM14 19H16V21H14zM18 19H20V21H18z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1ebf2",
    d: "M3 25H27V27H3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a074b9ed.svg";
export { ForwardRef as ReactComponent };